
              import { defineAsyncComponent } from 'vue'
              import SharedNodeRef from './app/render/components/generic/SharedNodeRef/SharedNodeRef.vue'
import PageBackground from './app/render/components/devlayout/PageBackground/PageBackground.vue'
import Container from './app/render/components/devlayout/Container/LayoutContainer.vue'
import Text from './app/render/components/devtest/Text/Text.vue'
import SelectionList from './app/render/components/devtest/SelectionList/SelectList.vue'
import OptionMultiSelect from './app/render/components/devtest/OptionMultiSelect/OptionMultiSelect.vue'
import CTA from './app/render/components/buttons/CTAButton/CTAButton.vue'
import OptionSingleSelect from './app/render/components/devtest/OptionSingleSelect/OptionSingleSelect.vue'
import StickyContainer from './app/render/components/devlayout/StickyContainer/StickyContainer.vue'
import Image from './app/render/components/devtest/Image/Image.vue'
import StyledContainer from './app/render/components/devlayout/StyledContainer/StyledContainer.vue'
import ColumnsOrRows from './app/render/components/devlayout/ColumnsOrRows/ColumnsOrRows.vue'
import StackedContainer from './app/render/components/devlayout/StackedContainer/StackedContainer.vue'
import AgeInput from './app/render/components/devtest/AgeInput/AgeInput.vue'
import MeasurementSwitcher from './app/render/components/devtest/MeasurementSwitcher/MeasurementSwitcher.vue'
import HeightInput from './app/render/components/devtest/HeightInput/HeightInput.vue'
import WeightInput from './app/render/components/devtest/WeightInput/WeightInput.vue'
import IconList from './app/render/components/devtest/IconList/IconList.vue'
import Timer from './app/render/components/devtest/Timer/Timer.vue'
import TextInput from './app/render/components/devtest/TextInput/TextInput.vue'
import EmailInput from './app/render/components/devtest/EmailInput/EmailInput.vue'
import Confetti from './app/render/components/devtest/Confetti/Confetti.vue'
import ScratchTicket from './app/render/components/devtest/ScratchTicket/ScratchTicket.vue'
import FullWidthContainer from './app/render/components/devlayout/FullWidthContainer/FullWidthContainer.vue'
import RitchTextTP from './app/render/components/devtest/RitchTextTP/RitchTextTP.vue'
import OptionSelectItem from './app/render/components/devtest/OptionSelectItem/OptionSelectItem.vue'
import Checkout from './app/render/components/devtest/Checkout/Checkout.vue'
import SavedCard from './app/render/components/devtest/SavedCard/SavedCard.vue'
import SpeechBubble from './app/render/components/devlayout/SpeechBubble/SpeechBubble.vue'
import SplitBackground from './app/render/components/devlayout/SplitBackground/SplitBackground.vue'
import ComponentSlot from './app/render/components/generic/ComponentSlot/ComponentSlot.vue'
import ProgressBarPOC from './app/render/components/devtest/ProgressBarPOC/ProgressBarPOC.vue'
import OfferSelectV2 from './app/render/components/devtest/OfferSelectV2/OfferSelectV2.vue'
import DiscountCode from './app/render/components/devtest/DiscountCode/DiscountCode.vue'
import OfferSelect from './app/render/components/devtest/OfferSelectComponent/OfferSelectComponent.vue'
              export default {
                'SharedNodeRef': { component: SharedNodeRef },
'PageBackground': { component: PageBackground },
'Container': { component: Container },
'Text': { component: Text },
'SelectionList': { component: SelectionList },
'OptionMultiSelect': { component: OptionMultiSelect },
'CTA': { component: CTA },
'OptionSingleSelect': { component: OptionSingleSelect },
'StickyContainer': { component: StickyContainer },
'Image': { component: Image },
'StyledContainer': { component: StyledContainer },
'ColumnsOrRows': { component: ColumnsOrRows },
'StackedContainer': { component: StackedContainer },
'AgeInput': { component: AgeInput },
'MeasurementSwitcher': { component: MeasurementSwitcher },
'HeightInput': { component: HeightInput },
'WeightInput': { component: WeightInput },
'IconList': { component: IconList },
'Timer': { component: Timer },
'TextInput': { component: TextInput },
'EmailInput': { component: EmailInput },
'Confetti': { component: Confetti },
'ScratchTicket': { component: ScratchTicket },
'FullWidthContainer': { component: FullWidthContainer },
'RitchTextTP': { component: RitchTextTP },
'OptionSelectItem': { component: OptionSelectItem },
'Checkout': { component: Checkout },
'SavedCard': { component: SavedCard },
'SpeechBubble': { component: SpeechBubble },
'SplitBackground': { component: SplitBackground },
'ComponentSlot': { component: ComponentSlot },
'ProgressBarPOC': { component: ProgressBarPOC },
'OfferSelectV2': { component: OfferSelectV2 },
'DiscountCode': { component: DiscountCode },
'OfferSelect': { component: OfferSelect }
              }
            